import './SelectArrow.scss';

function SelectArrow({ isOpen }) {
  const selectArrow  = isOpen ? 'select__arrow--up' : 'select__arrow--down';
  return (
    <div className={`select__arrow ${selectArrow}`}></div>
  )
}

export default SelectArrow;